import _ from 'lodash';
import template from './totalFlowModal.html';

export default {
  name: 'totalFlowSettingsModal',
  template,
  controller: TotalFlowSettingsModalController,
  controllerAs: 'TtlFlowSetModCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&'
  }
};

/* @ngInject */
function TotalFlowSettingsModalController(TotalFlowMeterService) {
  const vm = this;

  const gasesToCheck = [
    'fixedPercentN2',
    'fixedPercentCO2',
    'fixedPercentH2S',
    'fixedPercentH2O',
    'fixedPercentHelium',
    'fixedPercentMethane',
    'fixedPercentEthane',
    'fixedPercentPropane',
    'fixedPercentNButane',
    'fixedPercentIButane',
    'fixedPercentNPentane',
    'fixedPercentIPentane',
    'fixedPercentNHexane',
    'fixedPercentNHeptane',
    'fixedPercentNOctane',
    'fixedPercentNNonane',
    'fixedPercentNDecane',
    'fixedPercentOxygen',
    'fixedPercentCarbonMonoxide',
    'fixedPercentHydrogen',
    'fixedPercentArgon'
  ];
  const backUpSettings = {
    constants: {},
    gasConstants: {}
  };

  let totalFlow;

  vm.loadingSpinners = {};
  vm.totalFlowSettings = {
    constants: {},
    gasConstants: {}
  };
  vm.totalFlowModalInfo = {
    message: '',
    isSavingConstants: false,
    isSavingGasConstants: false
  };

  vm.$onInit = init;
  vm.checkAndSaveConstants = checkAndSaveConstants;
  vm.checkAndSaveGasConstants = checkAndSaveGasConstants;

  function init() {
    totalFlow = vm.resolve.totalFlow;

    TotalFlowMeterService.getConstants(totalFlow.id)
      .then((success) => {
        angular.copy(success.data, backUpSettings.constants);
        angular.copy(success.data, vm.totalFlowSettings.constants);
        vm.loadingSpinners.constants = true;
      })
      .catch((res) => {
        vm.loadingSpinners.constants = true;
        vm.totalFlowModalInfo.message =
            `An error occured, please close the modal and re-open to try again. Error: ${res.error}`;
      });

    TotalFlowMeterService.getGasConstants(totalFlow.id)
      .then((success) => {
        angular.copy(success.data, backUpSettings.gasConstants);
        angular.copy(success.data, vm.totalFlowSettings.gasConstants);
        vm.loadingSpinners.gasConstants = true;
      })
      .catch((res) => {
        vm.loadingSpinners.gasConstants = true;
        vm.totalFlowModalInfo.message =
            `An error occured, please close the modal and re-open to try again. Error: ${res.error}`;
      });
  }


  function checkAndSaveConstants() {
    vm.totalFlowModalInfo.isSavingConstants = true;
    vm.totalFlowModalInfo.message = 'Saving changes...';
    // parse through object properties and use _.pick to compare form with backup
    const changedConstantsToSend = _.reduce(vm.totalFlowSettings.constants, (constants, value, key) => {
      if (value !== backUpSettings.constants[key]) {
        constants = _.assign(constants, {
          [key]: value
        });
      }
      return constants;
    }, {});

    if (_.size(changedConstantsToSend)) {
      // send changed items.
      TotalFlowMeterService.setConstants(totalFlow.id, changedConstantsToSend)
        .then(() => {
          _.assign(backUpSettings.constants, changedConstantsToSend);
          vm.totalFlowModalInfo.message = 'Changes saved successfully';
          vm.totalFlowModalInfo.isSavingConstants = false;
        })
        .catch((res) => {
          vm.totalFlowModalInfo.message = `Error while saving:\n${res.error}`;
          vm.totalFlowModalInfo.isSavingConstants = false;
        });
    } else {
      vm.totalFlowModalInfo.message = 'No values have changed. Discarding save.';
      vm.totalFlowModalInfo.isSavingConstants = false;
    }
  }

  function checkAndSaveGasConstants() {
    vm.totalFlowModalInfo.isSavingGasConstants = true;
    vm.totalFlowModalInfo.message = 'Saving changes...';
    // parse through object properties and use _.pick to compare form with backup
    const gasConstants = vm.totalFlowSettings.gasConstants;
    _.reduce(gasesToCheck, (memo, gas) => {
      if (isNaN(gasConstants[gas])) {
        gasConstants[gas] = 0;
      }
      return memo.plus(gasConstants[gas]);
    }, Big(0)); // eslint-disable-line new-cap

    const changedGasConstantsToSend = _.reduce(gasConstants, (constants, value, key) => {
      if (value !== backUpSettings.gasConstants[key]) {
        constants = _.assign(constants, {
          [key]: value
        });
      }
      return constants;
    }, {});

    if (_.size(changedGasConstantsToSend)) {
      TotalFlowMeterService.setGasConstants(totalFlow.id, changedGasConstantsToSend)
        .then(() => {
          _.assign(backUpSettings.gasConstants, changedGasConstantsToSend);
          vm.totalFlowModalInfo.message = 'Changes saved successfully';
          vm.totalFlowModalInfo.isSavingGasConstants = false;
        })
        .catch((res) => {
          vm.totalFlowModalInfo.message = `Error while saving:\n${res.error}`;
          vm.totalFlowModalInfo.isSavingGasConstants = false;
        });
    } else {
      vm.totalFlowModalInfo.message = 'No values have changed. Discarding save.';
      vm.totalFlowModalInfo.isSavingGasConstants = false;
    }
  }
}
